export enum AbTestKeys {
	PlpOutletNewness = 'plp_outlet_newness',
	PlpOneColumnLayout = '_plp__mobile_1_column_layout',
	PromoBanner = 'promo_countdown',
	Test = 'test',
	Shopping_cart_pago_a_plazos = 'shopping_cart_pago_a_plazos',
	ShoppingCartPromoCodes = 'shopping_cart_promotional_codes',
	FeedbackAddToBag = 'shopping_cart_feedback_add_to_cart',
	PlpFirstFourSegmentation = 'plp_first_four_segmentation',
	PdpSizesSheet = 'pdp_sizes_sheet',
	NewSearchUi = 'search_new_ui_v2',
	PaymentsCobrandedCards = 'payments_cobranded_cards',
	PaymentsKlarnaInstallments = 'payments_klarna_installments',
	DeleteUserMenuTooltip = 'delete_user_menu_tooltip',
	CheckoutAccountCreation = '_checkout__account_creation',
	RegistryContactabilityWhatsapp = 'registry_contactability_whatsapp',
}
